/*  MUI  */
import { Badge } from '@mui/material';

/*  React  */
import React from 'react';

export const ExtensionInstalledBadge = ({
    children,
    extensionInstalled,
    avatarGroup = false
}) => {
    const anchorOriginPosition = avatarGroup
        ? { bottom: '2px', right: '3px' }
        : { bottom: '5px', right: '12px' };

    return (
        <Badge
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            badgeContent={1}
            color="secondary"
            overlap="rectangular"
            sx={{
                // Has to match anchorOrigin above
                '& .MuiBadge-anchorOriginBottomRight': anchorOriginPosition,
                '& .MuiBadge-badge': {
                    backgroundColor: extensionInstalled
                        ? 'icon.success'
                        : 'icon.danger'
                }
            }}
            variant="dot"
        >
            {children}
        </Badge>
    );
};
